/* ==========================================================================
   Fiche produit — visuels bord à bord dans la galerie (octobre 2026).
   Chargé par sections/pdp-fixes.liquid (fiche produit uniquement).

   Les visuels retouchés (fond gris uni, souvent carrés) laissaient des
   bandes #F8F8F8 sur les côtés du cadre de la galerie (format 8:7).

   - Si l'image a presque le format du cadre (au plus 8 % rogné de chaque
     côté), elle remplit tout le cadre (classe pdp-media-fill).
   - Sinon elle reste entière et le cadre prend la couleur des bords du
     visuel (classe pdp-media-edge), pour que les bandes ne se voient pas.
   - Les photos détourées sur fond blanc gardent le fond #F8F8F8 d'origine.

   Correctif (octobre 2026) : sur ordinateur et tablette (≥750px), les
   visuels retouchés ne sont plus jamais rognés (pdp-media-fill coupait
   le haut et le bas des visuels à textes intégrés, ex. « Comment
   l'utiliser ? »). Le cadre prend à la place le format exact de l'image
   (classe pdp-media-natural sur .product-media-container + variable
   --pdp-media-ratio) : image entière, proportions conservées, hauteur du
   cadre adaptée. Mobile (≤749px) inchangé.

   Styles associés : assets/component-pdp-media-background.css.
   ========================================================================== */
(function () {
  var SELECTOR = '.product__media-wrapper .product__media-item .product-media-container .media > img';
  var MAX_CROP_PER_SIDE = 0.08;
  var SAMPLE = 40;
  var naturalQuery = window.matchMedia('(min-width: 750px)');

  function edgeColor(img) {
    try {
      var canvas = document.createElement('canvas');
      canvas.width = SAMPLE;
      canvas.height = SAMPLE;
      var ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, SAMPLE, SAMPLE);
      var data = ctx.getImageData(0, 0, SAMPLE, SAMPLE).data;
      var last = SAMPLE - 1;
      var r = 0, g = 0, b = 0, n = 0;
      for (var i = 0; i < SAMPLE; i++) {
        [[i, 0], [i, last], [0, i], [last, i]].forEach(function (p) {
          var k = (p[1] * SAMPLE + p[0]) * 4;
          r += data[k];
          g += data[k + 1];
          b += data[k + 2];
          n++;
        });
      }
      return [Math.round(r / n), Math.round(g / n), Math.round(b / n)];
    } catch (e) {
      return null;
    }
  }

  function apply(img) {
    var box = img.closest('.product-media-container');
    if (!box || !img.naturalWidth) return;

    if (!box.dataset.pdpEdge) {
      var color = edgeColor(img);
      box.dataset.pdpEdge = color && Math.min.apply(null, color) < 246 ? 'rgb(' + color.join(',') + ')' : 'none';
    }
    var coloured = box.dataset.pdpEdge !== 'none';
    if (coloured) {
      box.style.background = box.dataset.pdpEdge;
      img.classList.add('pdp-media-edge');
    }

    var imageRatio = img.naturalWidth / img.naturalHeight;
    var natural = coloured && naturalQuery.matches;
    box.style.setProperty('--pdp-media-ratio', imageRatio);
    box.classList.toggle('pdp-media-natural', natural);
    if (natural) {
      img.classList.remove('pdp-media-fill');
      return;
    }

    var boxWidth = box.clientWidth;
    var boxHeight = box.clientHeight;
    if (!boxWidth || !boxHeight) return;
    var boxRatio = boxWidth / boxHeight;
    var crop = 1 - Math.min(imageRatio, boxRatio) / Math.max(imageRatio, boxRatio);
    img.classList.toggle('pdp-media-fill', crop / 2 <= MAX_CROP_PER_SIDE);
  }

  function watch(img) {
    if (img.dataset.pdpFill) return;
    img.dataset.pdpFill = 'true';
    if (img.complete && img.naturalWidth) apply(img);
    img.addEventListener('load', function () {
      var box = img.closest('.product-media-container');
      if (box) delete box.dataset.pdpEdge;
      apply(img);
    });
    var box = img.closest('.product-media-container');
    if (box && window.ResizeObserver) {
      new ResizeObserver(function () {
        apply(img);
      }).observe(box);
    }
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  naturalQuery.addEventListener('change', function () {
    document.querySelectorAll(SELECTOR).forEach(apply);
  });
})();
